import { FC, useCallback, useState } from 'react';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useDispatch, useStore } from 'react-redux';
import SettingsIcon from '@mui/icons-material/Settings';
import ProntoLogo from 'src/components/ProntoLogo';
import RenterNotificationIcon from 'src/components/NewRenterInterface/RenterNotificationIcon';
import { setTopBarHeight } from 'src/redux/slices/NewRenterInterface/NewRentersInterfaceUIManagementSlice';
import { RootState } from 'src/redux/rootReducerType';
import SettingsDrawer from './SettingsDrawer';

export const TOP_BAR_HEIGHT = 48;

const iconButtonSx = {
  backgroundColor: alpha('#FFFFFF', 0.125),
  borderRadius: '50%',
  width: 32,
  height: 32,
  color: 'common.white',
  '&:hover': { backgroundColor: alpha('#FFFFFF', 0.2) },
};

const RenterTopBar: FC = () => {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const dispatch = useDispatch();
  const store = useStore<RootState>();

  const topBarRefCallback = useCallback(
    (el: HTMLDivElement | null) => {
      if (!el) {
        return;
      }
      const height = el.getBoundingClientRect().height;
      const current = store.getState().newRenterUI.topBarHeight;
      if (current !== height) {
        dispatch(setTopBarHeight(height));
      }
    },
    [dispatch, store]
  );

  const handleOpenSettings = useCallback(() => {
    setSettingsOpen(true);
  }, []);

  const handleCloseSettings = useCallback(() => {
    setSettingsOpen(false);
  }, []);

  return (
    <AppBar
      ref={topBarRefCallback}
      position="fixed"
      elevation={0}
      sx={{
        borderBottom: 'none',
        backgroundColor: 'primary.dark',
        color: 'common.white',
      }}
    >
      <Toolbar
        variant="dense"
        sx={{ justifyContent: 'space-between', minHeight: TOP_BAR_HEIGHT }}
      >
        <ProntoLogo expanded height={28} fill="currentColor" />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              ...iconButtonSx,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <RenterNotificationIcon iconSize={18} iconColor="white" />
          </Box>
          <IconButton
            size="small"
            color="inherit"
            onClick={handleOpenSettings}
            sx={iconButtonSx}
            aria-label="Open settings"
          >
            <SettingsIcon fontSize="small" />
          </IconButton>
        </Box>
      </Toolbar>
      <SettingsDrawer open={settingsOpen} onClose={handleCloseSettings} />
    </AppBar>
  );
};

export default RenterTopBar;
